import { HomeComponent } from './Home.component';
import { enhance } from './Home.enhancers';

export const Home = enhance(HomeComponent);
